import { Button } from './Button';

export interface ConfirmationWidgetProps {
  question: string;
  options?: string[];
  selectedOption?: string;
  onSelect?: (option: string) => void;
  className?: string;
}

export function ConfirmationWidget({
  question,
  options = ['Yes', 'No'],
  selectedOption,
  onSelect,
  className = '',
}: ConfirmationWidgetProps) {
  if (selectedOption) {
    return (
      <div className={`p-sd-2 rounded-sd-md bg-sd-surface-elevated w-full ${className}`.trim()}>
        <p className="text-sd-sm text-sd-text mb-sd-2">{question}</p>
        <div className="flex items-center gap-sd-1">
          <svg className="w-4 h-4 text-sd-success shrink-0" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 8.5L6.5 12L13 4" />
          </svg>
          <span className="text-sd-sm text-sd-text font-medium">{selectedOption}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`p-sd-2 rounded-sd-md bg-sd-surface-elevated w-full ${className}`.trim()}>
      <p className="text-sd-sm text-sd-text mb-sd-2">{question}</p>
      <div className="flex flex-wrap gap-sd-2">
        {options.map((option) => (
          <Button
            key={option}
            variant="secondary"
            size="sm"
            onClick={() => onSelect?.(option)}
            className="flex-1 min-w-[80px] min-h-[44px]"
          >
            {option}
          </Button>
        ))}
      </div>
    </div>
  );
}
